import React from "react";
import {
  DashboardCard,
  PageTitle,
} from "@gsd/backoffice-ui";
import { Link } from "react-router-dom";

import {
  Row,
  Col,
  Spinner
} from "reactstrap";

interface CardInfo {
  route: any,
  img: any,
  description: any,
  label: any
}

const DashbardCardList = (props: { cards: CardInfo[] , isLoading: false}) => {
  return (
    <React.Fragment>
      <div className="pb-3">
        <PageTitle title="Dashboard"/>
      </div>
      { props.isLoading ? (
        <div className="text-center animated fadeIn">
          <Spinner
            style={{ width: "5rem", height: "5rem" }}
            color="primary"
          />
        </div>
      ) : null
      }
      <div className={props.isLoading ? "d-none" : ""}>
        <Row className="mx-xl-5">
          {props.cards.map((prop, i) => {
            return (
              <Col
                sm="6"
                md="4"
                className="pr-md-0"
                key={i}
              >
                <Link to={prop.route}>
                  <DashboardCard
                    icon={prop.img}
                    description={prop.description}
                    chiave={prop.label}
                  />
                </Link>
              </Col>
            );
          })}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default DashbardCardList;
